import Vue from 'vue';
import DomainStore from '@/app-shared/domain-store/index';
import { getQueryString } from '@/app-shared/utils/tool';
import { bu_appId } from '@/app-shared/global-data/businessData';
import router from '../router';
import {
  setEnv,
  setApiEnv,
  setBaseUrl,
  setRequestHeaders,
  setResponseInterceptors,
  useDocServer,
  useInteractiveServer,
  useRoomBaseServer,
  useMicServer,
  useMemberServer,
  useQaAdminServer,
  useGroupServer,
  useChatAuthServer,
  useMediaSettingServer,
  useUserServer,
  useInsertFileServer,
  useDesktopShareServer,
  useSplitScreenServer,
  useVideoPollingServer,
  useMediaCheckServer,
  useChatServer,
  useVirtualAudienceServer
} from 'middle-domain';
setApiEnv(process.env.VUE_APP_API_ENV || process.env.VUE_APP_API_ENV);
setEnv(process.env.VUE_APP_ENV);
setBaseUrl({
  v3Url: process.env.VUE_APP_BASE_URL,
  middleUrl: process.env.VUE_APP_MIDDLE_BASE_URL,
  wxBindBaseUrl: process.env.VUE_APP_BIND_BASE_URL,
  marketUrl: process.env.VUE_APP_MARKET_SERVICE_URL, // 新营销中心接口
  bizId: process.env.VUE_APP_BIZ_ID || 2,
  shortLinkBaseUrl: process.env.VUE_APP_SHORTlINK_URL // 短链接口基础地址
});
const linkToken =
  getQueryString('token') || getQueryString('liveT') || getQueryString('live_token') || '';

/**
 * 平台标识
 * wiki:
 */
setRequestHeaders({
  platform: 7, // 7:PC网页版
  token: linkToken ? '' : localStorage.getItem('token') || '', //如果地址栏有token则不设置token。优先级
  'biz-id': 2, //业务线标识 saas: 2 知客: 4
  'biz-application-id': process.env.VUE_APP_SAAS_ENV_DESC
    ? bu_appId[process.env.VUE_APP_SAAS_ENV_DESC]
    : bu_appId[process.env.VUE_APP_SAAS_ENV]
});

setResponseInterceptors(e => {
  //进入发起端，如果是本地token（非地址栏中的token或live_token）失效，清空token刷新页面跳转到B端登录页
  if (e.data.code == 511004) {
    router.push({ path: `/lives/error/0/${e.data.code}` });
    return;
  }
  if ([512506, 512507, 511058, 511005, 511006, 511007, 510008].includes(e.data.code)) {
    localStorage.removeItem('token');
    // prettier-ignore
    location.href = `${window.domainOfLive()}${process.env.VUE_APP_WEB_KEY}/login?${location.search}`;
  }
});
// 平台标识
window.platform = 7;

Vue.use(DomainStore);

export default new DomainStore.Store({
  state: {
    roomBaseServer: useRoomBaseServer().state,
    docServer: useDocServer().state,
    interactiveServer: useInteractiveServer().state,
    micServer: useMicServer().state,
    memberServer: useMemberServer().state,
    qaServer: useQaAdminServer().state,
    groupServer: useGroupServer().state,
    chatAuthServer: useChatAuthServer().state,
    mediaSettingServer: useMediaSettingServer().state,
    mediaCheckServer: useMediaCheckServer().state,
    userServer: useUserServer().state,
    insertFileServer: useInsertFileServer().state,
    desktopShareServer: useDesktopShareServer().state,
    splitScreenServer: useSplitScreenServer().state,
    videoPollingServer: useVideoPollingServer().state,
    chatServer: useChatServer().state,
    virtualAudienceServer: useVirtualAudienceServer().state
  }
});
